// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '../../app.js';
import * as Plugin_1 from '/data/jenkins_home/workspace/dev-gitlab-auto-build-web/go/src/github.com/axinan-com/goserver/web/projects/admin/fangorn/src/.umi-production/plugin-dva/runtime.tsx';
import * as Plugin_2 from '../plugin-initial-state/runtime';
import * as Plugin_3 from '../plugin-model/runtime';
import * as Plugin_4 from '@@/plugin-qiankun/masterRuntimePlugin';

  plugin.register({
    apply: Plugin_0,
    path: '../../app.js',
  });
  plugin.register({
    apply: Plugin_1,
    path: '/data/jenkins_home/workspace/dev-gitlab-auto-build-web/go/src/github.com/axinan-com/goserver/web/projects/admin/fangorn/src/.umi-production/plugin-dva/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_2,
    path: '../plugin-initial-state/runtime',
  });
  plugin.register({
    apply: Plugin_3,
    path: '../plugin-model/runtime',
  });
  plugin.register({
    apply: Plugin_4,
    path: '@@/plugin-qiankun/masterRuntimePlugin',
  });

export const __mfsu = 1;
